import { DATA_TEST_IDS } from '../consts';

export {
  getPromoError,
  getPromoStatusesInfo,
  getPromoStatus,
  mapPromoClip,
} from '../../ReportRequestForm/PromoSelector/utils';

export const getPromoDropdownTopBoundary = (fieldElement: HTMLElement, viewportGap: number): number | undefined => {
  const modalElement = fieldElement.closest(`[data-testid="${DATA_TEST_IDS.AUDIO_MODAL}"]`);
  const closeButton = modalElement?.querySelector<HTMLElement>('[data-testid="button_modal_screen_close"]');

  return closeButton ? closeButton.getBoundingClientRect().bottom + viewportGap : undefined;
};
